import {
  find as _find,
} from 'lodash';

import { FormattedMessage, InjectedIntl, MessageValue } from 'react-intl';

import { store } from 'src/redux/store.redux';
import { GlobalState } from '../models';

import { AvailableLanguagesExtended } from 'franke-trough-dependencies';
import translations from 'src/assets/i18n/messages';

export interface MessageDescriptor {
  id: string;
  description?: string;
  defaultMessage: string;
}

let theIntl: InjectedIntl;

export const getMessages = (language: AvailableLanguagesExtended = 'en-150'): {
  [key: string]: string;
} => {
  const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
  return translations[languageWithoutRegionCode] || translations[language] || translations.en;
};

export const formatMessage = (
  messageDescriptor: FormattedMessage.MessageDescriptor, 
  values?: {[key: string]: MessageValue}
): string => {
  
  if (theIntl) {
    // the caller has setup the full react-intl - just delegate to it!
    return theIntl.formatMessage(messageDescriptor, values);
  }

  const state: GlobalState = store && store.getState() as GlobalState;
  
  if (state && state.localize && state.localize.language.selected) {
    const messages = getMessages(state.localize.language.selected);
    const id = messageDescriptor.id;

    if (messages[id]) {
      return messages[id];
    }
  }

  return messageDescriptor.defaultMessage || '';  
};


export const formatDate = (
  value: any
): string => {
  if (theIntl) {
    // the caller has setup the full react-intl - just delegate to it!
    return theIntl.formatDate(value);
  }

  const state: GlobalState = store && store.getState() as GlobalState;
  
  if (state && state.localize && state.localize.language.selected) {
    return new Intl.DateTimeFormat(state.localize.language.selected).format(new Date(value));
  }

  return value;
};


export const formatNumber = (
  value: any,
  options?: ReactIntl.FormattedNumber.PropsBase
): string => {
  
  if (theIntl) {
    // the caller has setup the full react-intl - just delegate to it!
    return theIntl.formatNumber(value, options);
  }

  const state: GlobalState = store && store.getState() as GlobalState;
  
  if (state && state.localize && state.localize.language.selected) {
    return new Intl.NumberFormat(state.localize.language.selected, options).format(value);
  }

  return value;
};